import type { CreationCatalog } from './types';

/** Catálogo estático do mock — os ids batem com o servidor. */
export const MOCK_CATALOG: CreationCatalog = {
  professions: [
    {
      id: 'assassin', label: 'Assassino',
      stats: { str: 25, dex: 45, int: 10 },
      skills: [
        { id: 'fencing', value: 50, label: 'Esgrima' },
        { id: 'tactics', value: 30, label: 'Táticas' },
        { id: 'dodge', value: 20, label: 'Esquiva' }
      ]
    },
    {
      id: 'archer', label: 'Arqueiro',
      stats: { str: 20, dex: 50, int: 10 },
      skills: [
        { id: 'archery', value: 50, label: 'Arquearia' },
        { id: 'tactics', value: 30, label: 'Táticas' },
        { id: 'dodge', value: 20, label: 'Esquiva' }
      ]
    },
    {
      id: 'warrior', label: 'Guerreiro',
      stats: { str: 45, dex: 25, int: 10 },
      skills: [
        { id: 'axing', value: 50, label: 'Machados' },
        { id: 'tactics', value: 30, label: 'Táticas' },
        { id: 'healing', value: 20, label: 'Cura' }
      ]
    },
    {
      id: 'mage', label: 'Mago',
      stats: { str: 10, dex: 20, int: 50 },
      skills: [
        { id: 'magery', value: 50, label: 'Magia' },
        { id: 'meditation', value: 30, label: 'Meditação' },
        { id: 'magicResist', value: 20, label: 'Resistir Magia' }
      ]
    },
    {
      id: 'swordsman', label: 'Espadachim',
      stats: { str: 45, dex: 25, int: 10 },
      skills: [
        { id: 'swordsmanship', value: 50, label: 'Espadas' },
        { id: 'tactics', value: 30, label: 'Táticas' },
        { id: 'anatomy', value: 20, label: 'Anatomia' }
      ]
    }
  ],
  skills: [
    { id: 'swordsmanship', label: 'Espadas', group: 'combate' },
    { id: 'maceFighting', label: 'Maças', group: 'combate' },
    { id: 'fencing', label: 'Esgrima', group: 'combate' },
    { id: 'axing', label: 'Machados', group: 'combate' },
    { id: 'archery', label: 'Arquearia', group: 'combate' },
    { id: 'tactics', label: 'Táticas', group: 'combate' },
    { id: 'anatomy', label: 'Anatomia', group: 'combate' },
    { id: 'dodge', label: 'Esquiva', group: 'combate' },
    { id: 'magicResist', label: 'Resistir Magia', group: 'combate' },
    { id: 'healing', label: 'Cura', group: 'combate' },
    { id: 'magery', label: 'Magia', group: 'magia' },
    { id: 'meditation', label: 'Meditação', group: 'magia' },
    { id: 'evalInt', label: 'Avaliar Inteligência', group: 'magia' },
    { id: 'mining', label: 'Mineração', group: 'profissao' },
    { id: 'lumberjacking', label: 'Lenhador', group: 'profissao' },
    { id: 'blacksmithing', label: 'Ferraria', group: 'profissao' },
    { id: 'tailoring', label: 'Alfaiataria', group: 'profissao' },
    { id: 'fletching', label: 'Arcos e Flechas', group: 'profissao' }
  ],
  cities: [
    { id: 'minoc', label: 'Minoc', blurb: 'Mineração e ferraria; caverna próxima.' }
  ],
  maleHair: [
    { id: 'none', label: 'Rapado' }, { id: 'short', label: 'Curto' }, { id: 'long', label: 'Longo' },
    { id: 'ponytail', label: 'Rabo de cavalo' }, { id: 'mohawk', label: 'Moicano' },
    { id: 'pageboy', label: 'Pageboy' }, { id: 'receding', label: 'Entradas' },
    { id: 'pigtails', label: 'Maria-chiquinha' }, { id: 'topknot', label: 'Coque alto' }
  ],
  femaleHair: [
    { id: 'short', label: 'Curto' }, { id: 'long', label: 'Longo' },
    { id: 'ponytail', label: 'Rabo de cavalo' }, { id: 'mohawk', label: 'Moicano' },
    { id: 'pageboy', label: 'Pageboy' }, { id: 'buns', label: 'Coques' },
    { id: 'pigtails', label: 'Maria-chiquinha' }, { id: 'topknot', label: 'Coque alto' },
    { id: 'curly', label: 'Cacheado' }, { id: 'h-hair', label: 'h-hair' }
  ],
  beards: [
    { id: 'none', label: 'Nenhuma' }, { id: 'short', label: 'Curta' }, { id: 'long', label: 'Longa' },
    { id: 'goatee', label: 'Cavanhaque' }, { id: 'mustache', label: 'Bigode' },
    { id: 'shortBeard', label: 'Barba curta' }, { id: 'vandyke', label: 'Van Dyke' }
  ],
  skinHue: { min: 1002, max: 1058 },
  clothHue: { min: 1102, max: 1149 }
};

export const DEFAULT_APPEARANCE = {
  skinHue: 1009,
  hairStyle: 'short',
  hairHue: 1102,
  beardStyle: 'none' as string | null,
  beardHue: null as number | null,
  shirtHue: 1140,
  pantsHue: 1108
};
